// src/modules/app-views/account/pages/Subscription/tabs/RecordTab/SubscriptionCard.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Row, Col } from 'antd';
import translateX from 'utils/translateX';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleCountry from 'components/SimpleComponents/SimpleCountry';
import { SUBSCRIPTION_PROFILE_OPTIONS } from 'modules/app-views/account/service';
import app from 'configs/appResolver';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SubscriptionCard = () => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 2. HOOKS & REFS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 3. LOCAL VARIABLES I
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 4. LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 5. EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 6. HANDLERS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 7. LOCAL VARIABLES II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <Card
      className="no-shadow"
      title={<div className="text-muted">{translateX('organization')}</div>}
    >
      <Row gutter={16}>
        <Col xs={24} md={8}>
          <SimpleCountry name="countryCode" label="country" />
        </Col>
        <Col xs={24} md={8}>
          <SimpleInput name="organization" label="name" maxLength={100} autoFocus />
        </Col>
        {!app.PRESET?.PROFILE && (
          <Col xs={24} md={8}>
            <SimpleSelect name="profile" label="profile" options={SUBSCRIPTION_PROFILE_OPTIONS} />
          </Col>
        )}
      </Row>
    </Card>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SubscriptionCard;

// *******************************************************************************
// HELPERS
// *******************************************************************************
